import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import AllPreviousPdf from "../Components/AllPreviousPdf";
import "./Theme.css";
import "./WfirsDetails.css";

const WfirsDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  const [score, setScore] = useState([]);
  const [scoreCount, setScoreCount] = useState(0);
  const [reportUrl, setReportUrl] = useState("");

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchWFIRSSScore()
      .then((res) => {
        setScoreCount(res.data.score?.length || 0);
        setScore(res.data.score || []);
        setReportUrl(res.data.reportUrl || "");
      })
      .catch(() => {});
  }, []);

  const handleTakeWfirss = () => {
    const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;
    navigate(`/wfirs-s?${qs}`);
  };

  return (
    <section className="wfirs-entry-page">
      <div className="wfirs-entry-info">
        <p className="wfirs-entry-desc">{t("wfirsDetails.description")}</p>
        <button className="wfirs-entry-btn" onClick={handleTakeWfirss}>{t("wfirsDetails.takeBtn")}</button>
      </div>

      {scoreCount > 0 && (
        <div className="wfirs-entry-score-section">
          <h2 className="wfirs-entry-score-title">WFIRS-S</h2>
          <div className="wfirs-entry-score-row">
            <span className="wfirs-entry-score-val">{score} <span className="wfirs-entry-score-out">(Out of 207)</span></span>
            <a
              href={`https://goqii.com/app?fsn=244&fssn=0&fai=%7B%22url%22%3A%22${encodeURIComponent(reportUrl)}%22%2C%22title%22%3A%22WFIRSS-Report%22%7D`}
              className="wfirs-entry-report-btn"
            >
              {t("wfirsDetails.viewReport")}
            </a>
          </div>
          <h3 className="wfirs-entry-prev-title">{t("wfirsDetails.previousTitle")}</h3>
          <AllPreviousPdf />
        </div>
      )}
    </section>
  );
};

export default WfirsDetails;
